interface UserPayload {
  accessToken: string;
  id: string;
}

export const getUserPayload = (): UserPayload | null => {
  const qs = new URLSearchParams(window.location.search).get('payload');
  if (qs == null) {
    return null;
  }
  const { access_token: accessToken, id } = JSON.parse(atob(qs));
  return { accessToken, id };
};

export const getJwtToken = (): string | null => {
  const payload = getUserPayload();
  return payload && payload.accessToken;
};

export const getUserId = (): string | null => {
  const payload = getUserPayload();
  return payload && payload.id;
};
